export default __webpack_public_path__ + "static/media/pizza.d45c9440.jpg";